import styled from "styled-components";

export const Wrapper = styled.div``;

export const TextCenter = styled.div`
  text-align: center;
  * {
    text-align: center;
  }
`;

export const BadgesBoxOverflow = styled.div`
  max-width: 100%;
  padding: 0 24px;

  overflow: scroll;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::-webkit-scrollbar {
    width: 0px;
    opacity: 0;
    background-color: transparent;
    display: none;
  }
  &::-webkit-scrollbar:horizontal {
    opacity: 0;
    height: 0px;
    display: none;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    opacity: 0;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }
  @media (max-width: 1024px) {
    margin: 0 -24px;
    max-width: calc(100% + 48px);
    display: flex;
    padding: 0 36px;

    &::after {
      content: " ";
      display: block;
      width: 24px;
    }
  }
`;

export const BadgesBox = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 24px;
  justify-content: center;

  @media (min-width: 1024px) {
    display: flex;
    flex-wrap: wrap-reverse;
    flex-direction: row-reverse;
    gap: 32px 0;

    & > * {
      flex: 1 1 19%;
    }
    & > :nth-child(2) {
      flex: 1 1 48%;
    }
    & > :nth-child(1) {
      transform: translateX(-170px);
    }
    & > :nth-child(3) {
      transform: translateX(170px);
    }
  }
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .main-picture {
    width: 136px;
    height: 136px;
    object-fit: contain;
    object-position: center;
  }
  .label {
    border-radius: var(--rounding-radius-m, 16px);
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
    backdrop-filter: blur(12px);
  }
`;
